import React from 'react'
import { ReactNode } from 'react'
import HomeActionCard from './HomeActionCard'

interface CardHomeTeacherLinkProps {
  title: string
  subtitle: string
  icon: ReactNode
  path?: string
  /** Legado: o card do mockup não tem ilustração. Aceito e ignorado. */
  image?: string
}

/** Card de preparação de eventos — delega para o card único da Home. */
export default function CardHomeTeacherLink({
  title,
  subtitle,
  icon,
  path,
}: CardHomeTeacherLinkProps) {
  return <HomeActionCard icon={icon} title={title} description={subtitle} path={path} />
}
